var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCerifycert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 84,
    viewBox: "0 0 82 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.9167 62.8335L61.0834 83.6668L46.5001 69.0835L52.7501 62.8335L61.0834 71.1668L75.6667 56.5835L81.9167 62.8335ZM9.00008 0.333496C6.78994 0.333496 4.67033 1.21147 3.10752 2.77427C1.54472 4.33708 0.666748 6.45669 0.666748 8.66683V75.3335C0.666748 79.9585 4.37508 83.6668 9.00008 83.6668H41.5417C40.0417 81.0835 39.0001 78.2502 38.5001 75.3335H9.00008V8.66683H38.1667V29.5002H59.0001V46.5002C60.3751 46.2918 61.7917 46.1668 63.1667 46.1668C64.5834 46.1668 65.9584 46.2918 67.3334 46.5002V25.3335L42.3334 0.333496H9.00008ZM17.3334 42.0002V50.3335H50.6667V42.0002H17.3334ZM17.3334 58.6668V67.0002H38.1667V58.6668H17.3334Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCerifycert);
export default __webpack_public_path__ + "static/media/cerifycert.ecc76e597867a4ad452b49856c4f4c33.svg";
export { ForwardRef as ReactComponent };